import { RootState } from '@frontend/core'
import { uploadStatus } from './slice'

const entityAdapterSelectors = uploadStatus.getSelectors<RootState>(
  (state) => state.uploadStatus
)

export const {
  selectAll: selectAllUploadStatus,
  selectById: selectUploadStatusById,
  selectIds: selectUploadStatusIds,
  selectEntities: selectUploadStatusEntities,
  selectTotal: selectTotalUploadStatus
} = entityAdapterSelectors
